export const newData = [
  {
    title: 'New',
    links: [
      {
        title: 'All New Arrivals',
        url: '/collections/new-arrivals'
      },
      {
        title: 'New Furniture',
        url: '/collections/new-furniture'
      },
      {
        title: 'New Decor',
        url: '/collections/new-home-decor'
      },
      {
        title: 'Best Sellers',
        url: '/collections/bestsellers'
      }
    ]
  }
];

export const furnitureData = [
  {
    title: 'Bedroom',
    links: [
      {
        title: 'Beds',
        url: '/c/bedroom-furniture/beds'
      },
      {
        title: 'Headboards',
        url: '/c/bedroom-furniture/headboards'
      },
      {
        title: 'End of Bed Benches',
        url: '/c/living-room-furniture/benches'
      },
      {
        title: 'Matresses & Foundations',
        url: '/c/bedroom-furniture/mattresses-and-foundations'
      },
      {
        title: 'Nightstands',
        url: '/collections/nightstands'
      }
    ]
  },
  {
    title: 'Living Room',
    links: [
      {
        title: 'Sofas & Sectionals',
        url: '/c/living-room-furniture/sofas'
      },
      {
        title: 'Accent Chairs',
        url: '/c/living-room-furniture/chairs'
      },
      {
        title: 'Ottomans',
        url: '/c/living-room-furniture/ottomans'
      },
      {
        title: 'Cocktail Ottomans',
        url: '/c/living-room-furniture/cocktail-ottomans'
      },
      {
        title: 'Benches',
        url: '/c/living-room-furniture/benches'
      },
      {
        title: 'Coffee & Accent Tables',
        url: '/collections/coffee-tables-and-side-tables'
      }
    ]
  },
  {
    title: 'Dining Room',
    links: [
      {
        title: 'Dining Chairs',
        url: '/c/dining-room/dining-chairs'
      },
      {
        title: 'Bar & Counter Stools',
        url: '/c/categories/bar-and-counter-stools'
      }
    ]
  },
  {
    title: 'Quick Ship',
    links: [
      {
        title: 'Beds',
        url: '/c/bedroom-furniture/quick-ship-beds'
      },
      {
        title: 'Headboards',
        url: '/c/bedroom-furniture/quick-ship-headboards'
      },
      {
        title: 'Accent Chairs',
        url: '/c/bedroom-furniture/quick-ship-accent-chairs'
      },
      {
        title: 'Ottomans',
        url: '/c/bedroom-furniture/quick-ship-ottomans'
      },
    ]
  }
];

export const decorData = [
  {
    title: 'Decor',
    links: [
      {
        title: 'Throw Pillows',
        url: '/c/home-decor/throw-pillows'
      },
      {
        title: 'Curtains',
        url: '/c/home-decor/curtains'
      },
      {
        title: 'Bedding',
        url: '/collections/all-bedding'
      },
      {
        title: 'Wallpaper',
        url: '/collections/maximalist-wallpaper'
      },
      {
        title: 'Table Linens',
        url: '/c/home-decor/table-linens'
      },
      {
        title: 'Throw Blankets',
        url: '/collections/throw-blankets'
      },
      // {
      //   title: 'Decorative Screens',
      //   url: '/c/home-decor/room-dividers'
      // },
      {
        title: 'Rugs',
        url: '/collections/rugs'
      },
      {
        title: 'Lighting',
        url: '/collections/lighting'
      }
    ]
  }
];

export const outdoorData = [
  {
    title: 'Furniture',
    links: [
      {
        title: `Cabana Chairs`,
        url: '/c/outdoor-furniture/cabana-chairs'
      },
      {
        title: `Cabana Stools`,
        url: '/c/outdoor-furniture/cabana-stools'
      },
      // {
      //   title: `Cabana Bundles`,
      //   url: '/c/outdoor-furniture/cabana-bundles'
      // },
      {
        title: `Outdoor Pillows`,
        url: '/c/outdoor-furniture/outdoor-pillows'
      },
      {
        title: `Outdoor Rugs`,
        url: '/collections/outdoor-rugs'
      },
      {
        title: `Pickleball Paddles`,
        url: '/products/pickleball-paddle-by-recess-jade-cherry-blossom-48166'
      },
    ]
  }
];

export const windowData = [
  {
    title: 'Window',
    links: [
      {
        title: `All Curtains`,
        url: '/c/home-decor/curtains '
      },
      {
        title: `Best Selling Curtains`,
        url: '/collections/bestselling-curtains '
      },
      {
        title: `Floral Curtains`,
        url: '/collections/floral-curtains'
      },
      {
        title: `Animal Print Curtains`,
        url: '/collections/animal-print-curtains'
      },
      {
        title: `Striped Curtains`,
        url: '/collections/striped-curtains'
      },
      {
        title: `Velvet Curtains`,
        url: '/collections/velvet-curtains'
      },
    ]
  }
];

export const wallpaperData = [
  {
    title: 'Wallpaper',
    links: [
      {
        title: `All Wallpaper`,
        url: '/collections/maximalist-wallpaper'
      },
      {
        title: `Peel + Stick Wallpaper`,
        url: '/collections/peel-and-stick-wallpaper'
      },
      {
        title: `Traditional Wallpaper`,
        url: '/collections/traditional-wallpaper'
      },
      {
        title: `Best Selling Wallpaper`,
        url: '/collections/bestselling-wallpaper'
      },
      {
        title: `Floral Wallpaper`,
        url: '/collections/floral-wallpaper'
      },
      {
        title: `Animal Print Wallpaper`,
        url: '/collections/animal-print-wallpaper'
      },
      {
        title: `Striped Wallpaper`,
        url: '/collections/stripe-wallpaper'
      },
      {
        title: `Grasscloth Wallpaper`,
        url: '/products/grasscloth-wallpaper-roll-natural-raffia-35802?collection_id=234'
      },
      {
        title: `Wallpaper Swatches`,
        url: '/wallpaper-swatches'
      },
    ]
  }
];

export const beddingData = [
  {
    title: 'Bedding',
    links: [
      {
        title: `Duvets`,
        url: '/products/organic-cotton-duvet-cover-fullqueen-blue-delphine-139135'
      },
      {
        title: `Sheet Sets`,
        url: '/products/organic-cotton-sheet-set-queen-soft-blue-classic-ticking-stripe-139152'
      },
      {
        title: `Shams`,
        url: '/products/organic-cotton-shams-euro-rose-peacock-park-139213'
      },
      {
        title: `Pillow Cases`,
        url: '/products/organic-cotton-pillowcases-standard-soft-blush-139248'
      }
    ]
  }
];

export const fabricData = [
  {
    title: 'Fabric by the Yard',
    links: [
      {
        title: `All Fabric by the Yard`,
        url: '/c/fabric-by-the-yard/fabric-by-the-yard'
      },
      {
        title: `Best Selling Fabrics`,
        url: '/collections/bestselling-fabric-by-the-yard'
      },
      {
        title: `Floral Prints`,
        url: '/collections/floral-fabric-by-the-yard'
      },
      {
        title: `Animal Prints`,
        url: '/collections/animal-print-fabric-by-the-yard'
      },
      {
        title: `Velvets`,
        url: '/collections/velvet-fabric-by-the-yard'
      },
      {
        title: `Kid & Pet Friendly`,
        url: '/collections/performance-fabric-by-the-yard'
      }
    ]
  }
];

export const inspirationData = [
  {
    title: 'Inspiration',
    links: [
      {
        title: 'House Tours',
        url: '/house-tours'
      },
      {
        title: 'Bedroom',
        url: '/theinside-irl?menu%5Brooms%5D=Bedroom&page=1'
      },
      {
        title: 'Living',
        url: '/theinside-irl?menu%5Brooms%5D=Living%20Room&page=1'
      },
      {
        title: 'Dining',
        url: '/theinside-irl?menu%5Brooms%5D=Dining%20Room&page=1'
      },
      {
        title: 'Outdoor',
        url: '/theinside-irl?menu%5Brooms%5D=Outdoor&page=1'
      },
      {
        title: 'Entryway',
        url: '/theinside-irl?menu%5Brooms%5D=Entryway&page=1'
      },
      {
        title: 'Baby & Kids',
        url: '/theinside-irl?menu%5Brooms%5D=Baby%20%26%20Kids&page=1'
      }
    ]
  }
];

export const collabData = [
  {
    title: 'Collaborations',
    links: [
      {
        title: 'Old World Weavers',
        url: '/collaborators/oldworldweavers'
      },
      {
        title: 'Scalamandré',
        url: '/collaborators/scalamandre'
      },
      {
        title: 'CW Stockwell',
        url: '/collaborators/cw-stockwell'
      }
      ],
  }
];

export const swatchesData = [
  {
    title: 'Swatches',
    links: [
      {
        title: 'Fabric Swatches',
        url: '/fabric-swatches'
      },
      {
        title: 'Wallpaper Swatches',
        url: '/wallpaper-swatches'
      }
    ]
  }
];

export const tradeData = [
  {
    title: 'Trade',
    links: [
      {
        title: 'Apply for Trade account',
        url: '/design-trade-services'
      },
      {
        mailto: true,
        title: 'Contact Us',
        url: 'mailto:trade@theinside.com'
      }
    ]
  }
];


